export default {
  bind(el, binding, vnode) {
    const delay = Number(binding.arg) || 500;
    let timeout;

    const handler = (event) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const value = event?.target?.value;
        binding.value.call(vnode.context, value, event);
      }, delay);
    };

    el.addEventListener('input', handler);
    el._debounceCleanup = () => el.removeEventListener('input', handler);
  },

  unbind(el) {
    el._debounceCleanup?.();
  },
};
